<template>
  <div>
    <svg viewBox="0 0 694 93" xmlns="http://www.w3.org/2000/svg" class="transition duration-300 ease-in-out delay-150">
      <defs>
        <linearGradient id="gradient">
          <stop offset="0%" stop-color="#236f99" />
          <stop offset="100%" stop-color="#4cbdd5" />
        </linearGradient>
      </defs>
      <g>
        <title>Layer 1</title>
        <path
          stroke="null"
          id="svg_1"
          class="transition-all duration-300 ease-in-out delay-150"
          fill="url(#gradient)"
          stroke-width="0"
          d="m0.00003,94c0,0 0,-70.60842 0,-70.60842c78.50926,8.23765 157.01852,16.4753 235.52778,10.9443c78.50926,-5.53099 157.01852,-24.83063 233.59722,-28.94945c76.57871,-4.11883 151.22685,6.94316 225.875,18.00515c0,0 0,70.60842 0,70.60842l-695,0z"
        />
      </g>
    </svg>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>